// Based on vue2-utils
// A way to return the currentRoute on a reactive way

import type { Route } from 'vue-router'
import type VueRouter from 'vue-router'

import { effectScope, getCurrentInstance, reactive } from 'vue'

let currentRoute: Route

export function useRouter(): VueRouter {
    const instance = getCurrentInstance()
    if (instance?.proxy) {
        return instance.proxy!.$root.$router
    }
    return undefined as any
}

export function useRoute(): Route {
    const router = useRouter()
    if (!router) {
        console.warn('No router detected')
        return undefined as any
    }

    if (!currentRoute) {
        // Catch the active effectScope
        const scope = effectScope(true)
        scope.run(() => {
            // Attach to Vue rendering engine
            currentRoute = reactive(assign({}, router.currentRoute)) as Route
            // Now reassign the value
            router.afterEach(to => {
                assign(currentRoute, to)
            })
        })
    }
    return currentRoute
}

function assign(target: Record<string, any>, source: Record<string, any>) {
    for (const key of Object.keys(source)) {
        target[key] = source[key]
    }
    return target
}
